import { Box, TextField } from "@mui/material";

import React from "react";

export default function ColorPicker({ value, onChange, name, labelText }) {
  return (
    <Box className="flex flex-col gap-1">
      <label className="text-xs">
        <b>{labelText}</b>
      </label>
      <Box className="flex gap-1 items-center">
        <input
          value={value}
          onChange={onChange}
          name={name}
          type="color"
          style={{
            border: "none",
            outline: "none",
            width: 30,
            cursor: "pointer",
            borderRadius: "40px",
          }}
        />
        <label className="text-xs">{value}</label>
      </Box>
    </Box>
  );
}
